import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 获取工单列表
 */
export function getMaintainOrderList(data) {
  return fetch({
    url: '/maintain/manage/maintain/order/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 编辑单位
 */
export function editUnit(data) {
  return fetch({
    url: '/auth/unit/edit',
    method: 'POST',
    data
  })
}


/**
 * @param {idList[]} data
 * 删除工单
 */
export function deleteOrder(data) {
  return fetch({
    url: '/maintain/manage/maintain/order/deleteOrder',
    method: 'POST',
    data
  })
}


/**
 * @param {id} params
 * 导出PDF
 */
export function exportPDF(params) {
  return formAxios({
    url: '/maintain/manage/maintain/order/exportPdf',
    method: 'GET',
    params
  })
}

/**
 * @param {idList[]} data
 * 批量导出工单
 */
export function batchExportPDF(data) {
  return formAxios({
    url: '/maintain/manage/maintain/order/exportPdfBatch',
    method: 'POST',
    data
  })
}


/**
 * @param {}
 * 导出EXAIL
 */
export function exportEXAIL(data) {
  return formAxios({
    url: '/maintain/manage/maintain/order/exportTemplateList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 获取部门列表
 */
export function getDepartmentTree(params) {
  return fetch({
    url: '/auth/department/getDepartmentTree',
    method: 'GET',
    params
  })
}


/**
 * @param {orderId} params
 * 根据部门id获取工单详情
 */
export function getOrderDetailInfo(params) {
  return fetch({
    url: '/maintain/manage/maintain/order/getOrderDetailInfo',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} data
 * 根据unitId和部门id获取项目
 */
export function getProjectLiftTree(params) {
  return fetch({
    url: '/maintain/project/projectLiftTree',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} params
 * 根据部门id获取部门详情
 */
export function getDepartmentDetail(params) {
  return fetch({
    url: '/auth/department/detail',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} data
 * 获取项目
 */
export function getProjectSimpleList(data) {
  return fetch({
    url: '/maintain/project/simpleList',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 获取使用单位列表
 */
export function getPropertyUnitSimpleList(data) {
  return fetch({
    url: '/auth/subPlatform/propertyUnit/simpleList',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 更新推送
 */
export function orderPush(data) {
  return fetch({
    url: '/maintain/manage/maintain/order/orderPush',
    method: 'POST',
    data
  })
}
/**
 * @param {Object} data
 * 审核工单
 */
export function processStatus(data) {
  return fetch({
    url: '/maintain/manage/maintain/order/processStatus',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 复制工单结果
 */
export function copyResult(data) {
  return fetch({
    url: '/maintain/manage/maintain/order/copyResult',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 工单结果图片修改
 */
export function updateImage(data) {
  return fetch({
    url: '/maintain/manage/maintain/order/updateImage',
    method: 'POST',
    data
  })
}





// WEBPACK FOOTER //
// ./src/api/MaintenanceWorkOrder/index.js